﻿'use strict';

angular.module('ntmApp')
  .controller('staffNotesController', ['$scope', '$uibModalInstance', 'data', 'Constants', 'ConfirmationService', 'DailyPlanService', 'FlashService',
      function ($scope, $uibModalInstance, data, Constants, ConfirmationService, DailyPlanService, FlashService) {

          var init = function () {
              $scope.selectedActivityItemForNote = {
                  scheduleID: data.selectedActivity.scheduleId,
                  activityName: data.selectedActivity.activity,
                  groupName: data.groupName
              };

              $scope.activityNoteText = data.selectedActivity.activityNotes;
          };

          $scope.areThereUnsavedChanges = function () {
              return !angular.equals($scope.activityNoteText, data.selectedActivity.activityNotes);
          };

          $scope.updateStaffNote = function () {

              var request = {
                  scheduleID: $scope.selectedActivityItemForNote.scheduleID,
                  notes: $scope.activityNoteText,
                  action: Constants.DBActions.Update,
              };

              var loading = FlashService.Loading();
              DailyPlanService.EditStaffNotes(request).then(function (result) {

                  if (result.success) {
                      FlashService.Success('Staff notes have been updated.');

                      data.selectedActivity.activityNotes = $scope.activityNoteText;

                      $scope.close();
                  }

                  loading.dismiss();
              });
          };

          $scope.close = function () {
              event.preventDefault();

              if (!$scope.areThereUnsavedChanges()) {
                  $uibModalInstance.close();
              } else {
                  ConfirmationService.YesNoConfirmation("Save pending changes?", null, { no: 'No', yes: 'Yes' })
                 .Yes($scope.updateStaffNote)
                 .No(function () {
                     $uibModalInstance.close();
                 })
                 .Ask();
              }
          };

          $scope.$on('modal.closing', function (event, reason) {
              switch (reason) {
                  // clicked outside
                  case "backdrop click":
                      event.preventDefault();
                      $scope.close(event);
                      break;
                      // escape key
                  case "escape key press":
                      event.preventDefault();
                      $scope.close(event);
                      break;
              }
          });

          $scope.cancel = function (closeType) {
              $uibModalInstance.close(closeType || false);
          };

          init();
      }]);